import { PlanPurchaseExperienceMode } from '@dtx-company/true-common/src/types/Plan'
import { PlanPurchaseExperienceProps } from '@app/common/src/components/PlanPurchaseExperience/types'
import { usePlanPricingGroup } from '@dtx-company/inter-app/src/hooks/usePlanPricingGroup/usePlanPricingGroup'
import { usePlanPurchaseExperienceSubscriptionInfo } from '@app/common/src/components/PlanPurchaseExperience/hooks/usePlanPurchaseExperienceSubscriptionInfo'

export function usePlanPurchaseExperiencePricingGroup(
  props: PlanPurchaseExperienceProps
): string | undefined {
  const { currentSubscriptionInfoSWR, currentSubscriptionInfoData } =
    usePlanPurchaseExperienceSubscriptionInfo()
  const globalPlanPricingGroup = usePlanPricingGroup()
  const currentPlanPricingGroup = currentSubscriptionInfoData?.plan.group
  if (currentSubscriptionInfoSWR.isLoading) return
  // The current plan's price can be different from the global pricing group
  // When purchasing addons, we want to stay on the current plan's group
  if (props.mode === PlanPurchaseExperienceMode.PURCHASE_ADDONS && currentPlanPricingGroup) {
    return currentPlanPricingGroup
  }
  return globalPlanPricingGroup
}
